import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import LiaErrorBoundary from "../../components/LiaErrorBoundary";
import Loader from "../../components/Loader";
import { useAuth } from "../services/eqqo.auth.service";

const RequireAuth = ({ children }) => {
	const { isLoggingIn, user } = useAuth();
	const location = useLocation();
	return isLoggingIn
		? <Loader />
		: user
			? <LiaErrorBoundary>{children}</LiaErrorBoundary>
			: <Navigate to={`/sign-in?redirect=${location.pathname}`} />;
};

RequireAuth.propTypes = {
	children: PropTypes.node.isRequired
};

export default RequireAuth;